<template>
	<div id="app" :class="appclass">
		<div id="be" class="container m-auto px-6">
			<div class="flex flex-wrap">
				<div class="w-12">
					<div class="be">
						Be hungry.
						<br />
						Be humble.
					</div>
				</div>
			</div>
		</div>

		<main id="main" class="container m-auto h-full px-6">
			<div class="entry w-full">
				<transition name="slide" mode="out-in">
					<router-view/>
				</transition>
			</div>
		</main>

		<div class="landscape hidden items-center justify-center">
			<div>Please rotate your device.<br />Thank you!</div>
		</div>
	</div>
</template>

<script>

import { mapState } from 'vuex';

export default {
	name: 'App',
	computed: {
		...mapState([
			'appclass'
		])
	},
};

</script>

<style lang="scss">

@import './assets/scss/app.scss';

</style>
